import { components, OptionProps } from "react-select";
import classNames from "classnames";

import { ISelectCarmaOption, ISelectCarmaOptionType } from "../../types";

import styles from "./CustomOption.module.css";



const CustomOption = (props: OptionProps<ISelectCarmaOption>) => {
  const { data } = props;

  const innerProps = {
    ...props.innerProps,
    ...(data.onClick && { onClick: data.onClick }),
  }

  const innerClassName = classNames({
    [styles["button"]]: data.type === ISelectCarmaOptionType.Button,
  });

  const className = classNames(styles["option"], {
    [styles["is-button"]]: data.type === ISelectCarmaOptionType.Button,  
  });

  return (
    <components.Option {...props} className={innerClassName} innerProps={innerProps}>
      <div className={className}>
        <span className={styles["option__label"]}>{data.label}</span>
        {data.score && (
          <span className={styles["option__score"]}>{String(data.score)}</span>
        )}
        {data.icon && data.icon}
      </div>
    </components.Option>
  );
};

export default CustomOption;
